module.exports = __webpack_public_path__ + "img/icon_start.5d0498aa-75525aba.60cc844c.svg";